module.exports = __webpack_public_path__ + "static/media/pro_workout_img.10026a2c.svg";